(function () {
    var SlideNavLeftController = /** @class */ (function () {
        /**
         * 
         * @param $mdDialog
         * @param AuthService{AuthService}
         * @param $state
         * @param $mdSidenav
         * @param localStorageService
         * @param $rootScope
         * @param NotificationService{NotificationService}
         * @constructor
         */
        function SlideNavLeftController($mdDialog, AuthService, $state, $mdSidenav, localStorageService, $rootScope, NotificationService) {
            var _this = this;
            this.$mdDialog = $mdDialog;
            this.AuthService = AuthService;
            this.$state = $state;
            this.$mdSidenav = $mdSidenav;
            this.localStorageService = localStorageService;
            this.$rootScope = $rootScope;
            this.notificationService = NotificationService;
            this.user = this.AuthService.getAuthenticatedUser();
            this.$rootScope.$on("update-profile", function () {                
                _this.user = _this.AuthService.getAuthenticatedUser();
            });


            this.showingMenu = true;

            // This only fire on login screen when direct change language
            this.$rootScope.$on("language-changed", function () {
                // simulate refresh so that the control can re-tranlate

                _this.showingMenu = false;
                setTimeout(() => {
                    _this.showingMenu = true;
                }, 100);
            });

            
        }
        /**
         * Close nav left with anination
         * @returns {angular.IPromise<void>}
         */
        SlideNavLeftController.prototype.closeSideNav = function () {
            return this.$mdSidenav('left').close();
        };
        /**
         * Close nav left without animation
         */
        SlideNavLeftController.prototype.closeSideNavImmediately = function () {
            $("md-sidenav[md-component-id='left']").addClass('md-closed');
            this.$mdSidenav('left').close();
        };
        /**
         * Show profile modal
         * @param {MouseEvent} $event
         */
        SlideNavLeftController.prototype.showProfilePopup = function ($event) {
            this.closeSideNavImmediately();
            this.$mdDialog.show({
                controller: 'ProfileController',
                controllerAs: 'vm',
                templateUrl: 'js/internal/profile/profile.view.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                // hasBackdrop: false,
                clickOutsideToClose: false,
                escapeToClose: false,
                fullscreen: true
            });
        };
        /**
         * Show change password modal
         * @param {MouseEvent} $event
         */
        SlideNavLeftController.prototype.showChangePasswordModal = function ($event) {
            this.closeSideNavImmediately();
            this.AuthService.showChangePassword(null);
        };
        /**
         * Show about modal
         * @param {MouseEvent} $event
         */
        SlideNavLeftController.prototype.showAboutModal = function ($event) {
            this.closeSideNavImmediately();
            this.$mdDialog.show({
                controller: 'AboutController',
                controllerAs: 'vm',
                templateUrl: 'js/internal/about/about.view.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                fullscreen: true
            });
        };
        /**
         * Logout the application
         */
        SlideNavLeftController.prototype.logout = function () {
            var _this = this;
            this.AuthService.logout().then(function () {
                _this.closeSideNavImmediately();
                _this.$state.go("internal.login");
            });
        };

        SlideNavLeftController.prototype.showChangeLanguageModal = function ($event) {
            this.closeSideNavImmediately();
            this.$mdDialog.show({
                controller: 'ChangeLanguageController',
                controllerAs: 'vm',
                templateUrl: 'js/internal/change-language/change-language.view.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                fullscreen: true
            });
        }
        
        SlideNavLeftController.prototype.onSwipeLeft = function () {
            this.closeSideNav();
        };
        SlideNavLeftController.prototype.gotoNotifications = function () {
            this.closeSideNav(); // Close left menu
            this.$state.go("internal.notifications"); // go to Notification Module
        };
        SlideNavLeftController.prototype.showMyDocuments = function () {
            this.closeSideNav(); // Close left menu
            this.$state.go("internal.documents"); // go to Documents Module
        };

        SlideNavLeftController.$inject = ['$mdDialog', 'AuthService', '$state', '$mdSidenav', 'localStorageService', '$rootScope', 'NotificationService'];
        return SlideNavLeftController;
    }());
    angular.module('internal.slidenavleft', []).controller('SlideNavLeftController', SlideNavLeftController);
})();
